export default __webpack_public_path__ + "static/char-57-054818f033e8043177015a4f3568e74d.webp";